/* BeautyCorner — filters for collections over Shopify's 5,000-product filter limit.
 *
 * Shopify sends no filters for such a collection and ignores filter.* URL params on it. The
 * collection is therefore split into hidden partition collections "bcp-<handle>-<n>"
 * (fix-log/filters/partitions.py), each small enough to filter natively.
 *
 * The theme filters by fetching "<collection url>?section_id=<grid section>&<params>" and
 * re-rendering its sidebar, drawer, bar and grid from the response. On these collections this
 * script answers that fetch itself, with a document merged from the partitions
 * (sections/bc-partition-data.liquid): facet counts summed, values united, products merged in
 * sort order. The theme then renders everything as for any other collection — URL, history,
 * sort, chips, mobile drawer, price slider all stay native. Further products load through the
 * theme's infinite scroll (Ajaxinate XHR), which this script also answers ("?bc_more=").
 * Without filters the grid stays the collection's own (its own order and pagination); only
 * the filter UI comes from the partitions.
 */
(function () {
  var cfgEl = document.getElementById('bc-big-config');
  if (!cfgEl || window.bcBigLoaded) return;
  window.bcBigLoaded = true;

  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }
  var vendors = cfg.vendors;
  if (typeof vendors === 'string') {
    try { vendors = JSON.parse(vendors); } catch (e) { vendors = []; }
  }
  if (!Array.isArray(vendors)) vendors = [];

  var PER = 16; // page size of sections/bc-partition-data.liquid
  var root = cfg.root === '/' ? '' : String(cfg.root).replace(/\/$/, '');
  var path = location.pathname;
  var realFetch = window.fetch.bind(window);
  var partRe = new RegExp('/collections/bcp-' + cfg.parent.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '-\\d+', 'g');
  var htmlEl = document.documentElement;
  var defaultSort = (document.querySelector('[data-filter-bar] input[name="sort_by"]:checked') || {}).value || '';
  var firstRender = true;
  var cache = {};
  var st = null; // merged product list behind "load more"

  // Fixed value order where the order means something (mirrors snippets/filter-drawer-group.liquid)
  var FIXED = {
    'filter.p.m.bc_filter.size': ['Up to 10 ml', '11-30 ml', '31-50 ml', '51-100 ml', '101-200 ml', 'Over 200 ml'],
    'filter.p.m.bc_filter.gender': ['Women', 'Men', 'Unisex', 'Kids'],
    'filter.p.m.bc_filter.concentration': ['Extrait de Parfum', 'Parfum', 'Eau de Parfum', 'Eau de Toilette', 'Eau de Cologne', 'Perfume Oil'],
    'filter.p.m.bc_filter.spf': ['SPF 50+', 'SPF 30-49', 'SPF 15-29', 'Below SPF 15'],
    'filter.v.availability': ['1', '0']
  };
  // Quick-filter pills (mirrors snippets/bc-quick-filters.liquid)
  var PILLS = [
    'filter.p.m.bc_filter.category',
    'filter.p.m.bc_filter.gender',
    'filter.p.m.bc_filter.concentration',
    'filter.p.m.bc_filter.format',
    'filter.p.m.bc_filter.skin_concern',
    'filter.p.m.bc_filter.hair_concern',
    'filter.p.m.bc_filter.fragrance_family'
  ];

  // ---------------------------------------------------------------- helpers

  function norm(s) {
    return (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9\u0370-\u03ff]+/g, '');
  }
  function liquidEncode(s) {
    return encodeURIComponent(s).replace(/%20/g, '+');
  }
  function escHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  var scratch = document.createElement('div');
  function textOf(h) {
    scratch.innerHTML = h;
    return scratch.textContent;
  }
  function cssEsc(s) {
    return window.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/["\\]/g, '\\$&');
  }

  function cleanParams(qs) {
    var src = new URLSearchParams(qs);
    var out = new URLSearchParams();
    src.forEach(function (v, k) {
      if (k === 'section_id' || k === 'page' || k === 'bc_more' || v === '') return;
      out.append(k, v);
    });
    return out;
  }
  function isFilter(k) {
    return k.indexOf('filter.') === 0;
  }
  function hasFilter(params) {
    var f = false;
    params.forEach(function (v, k) { if (isFilter(k)) f = true; });
    return f;
  }
  function without(params, name, value) {
    var out = new URLSearchParams();
    var dropped = false;
    params.forEach(function (v, k) {
      if (!dropped && k === name && v === value) {
        dropped = true;
        return;
      }
      out.append(k, v);
    });
    return out;
  }
  function resultsText(n) {
    if (n === 1) return cfg.t.one.replace('__N__', n);
    if (n > 1) return cfg.t.many.replace('__N__', n);
    return cfg.t.none;
  }

  // ---------------------------------------------------------------- partitions

  function partUrl(handle, q, page) {
    return root + '/collections/' + handle + '?section_id=bc-partition-data' + (q ? '&' + q : '') + (page > 1 ? '&page=' + page : '');
  }

  function loadPage(handle, q, page) {
    return realFetch(partUrl(handle, q, page), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('bc-bigfilter: ' + r.status);
        return r.text();
      })
      .then(function (text) {
        // product and chip links point at the partition; they belong to the collection
        var doc = new DOMParser().parseFromString(text.replace(partRe, '/collections/' + cfg.parent), 'text/html');
        var json = doc.querySelector('[data-bc-json]');
        var box = doc.querySelector('[data-bc-items]');
        var items = [];
        if (box) {
          box.querySelectorAll('[data-bc-sort]').forEach(function (el) {
            var k = el.getAttribute('data-bc-sort').split('|');
            items.push({
              html: el.outerHTML,
              price: +k[0] || 0,
              created: +k[1] || 0,
              id: k[2],
              title: k.slice(3).join('|').toLowerCase()
            });
          });
        }
        return {
          handle: handle,
          doc: doc,
          data: json ? JSON.parse(json.textContent) : { count: 0, filters: [] },
          items: items,
          pages: box ? +box.getAttribute('data-bc-pages') || 1 : 1
        };
      });
  }

  function loadAll(q) {
    if (!cache[q]) {
      cache[q] = Promise.all(cfg.parts.map(function (h) { return loadPage(h, q, 1); }));
      cache[q].catch(function () { delete cache[q]; });
    }
    return cache[q];
  }

  // ---------------------------------------------------------------- filters

  function mergeFilters(parts, params) {
    var order = [];
    var by = {};
    parts.forEach(function (pt) {
      (pt.data.filters || []).forEach(function (f) {
        var m = by[f.p];
        if (!m) {
          m = by[f.p] = { p: f.p, t: f.t, map: {}, list: [], rmax: 0, rmaxf: '', rmaxf0: null };
          order.push(f.p);
        }
        if (f.t === 'price_range') {
          if (m.rmaxf0 === null) m.rmaxf0 = f.rmaxf;
          if (f.rmax > m.rmax) {
            m.rmax = f.rmax;
            m.rmaxf = f.rmaxf;
          }
          return;
        }
        (f.v || []).forEach(function (v) {
          var e = m.map[v[0]];
          if (!e) {
            e = m.map[v[0]] = { v: v[0], l: v[1], c: 0, a: false };
            m.list.push(e);
          }
          e.c += v[2];
          if (v[3]) e.a = true;
        });
      });
    });
    // a selected value stays visible even when no partition lists it (long-tail brands)
    params.forEach(function (v, k) {
      var m = by[k];
      if (!m || m.t === 'price_range') return;
      var e = m.map[v];
      if (!e) {
        e = m.map[v] = { v: v, l: escHtml(v), c: 0, a: true };
        m.list.push(e);
      }
      e.a = true;
    });
    return order.map(function (p) { return by[p]; });
  }

  function present(m, otherActive) {
    var vis = m.list.filter(function (e) { return e.c > 0 || e.a; });
    var res = {
      items: vis,
      limit: m.p === 'filter.p.vendor' ? 10 : 8,
      hidden: 0,
      open: false,
      tail: [],
      hide: vis.length < 2 && !vis.some(function (e) { return e.a; })
    };
    var brand = false;
    var fixed = FIXED[m.p];
    var byLabel = function (a, b) { return norm(textOf(a.l)).localeCompare(norm(textOf(b.l))); };
    if (fixed) {
      var rank = function (e) { var i = fixed.indexOf(e.v); return i < 0 ? 999 : i; };
      res.items = vis.slice().sort(function (a, b) { return rank(a) - rank(b); });
    } else if (m.p === 'filter.p.vendor') {
      if (vis.length > res.limit) {
        // the biggest brands first, then everything else A–Z (+ brands beyond Shopify's 100 values)
        brand = true;
        var byCount = vis.slice().sort(function (a, b) { return b.c - a.c; });
        var rest = byCount.slice(res.limit).sort(byLabel);
        res.items = byCount.slice(0, res.limit).concat(rest);
        if (!otherActive) {
          var seen = {};
          vis.forEach(function (e) { seen[norm(e.v)] = true; });
          vendors.forEach(function (entry) {
            var cut = entry.lastIndexOf('|');
            var name = cut > 0 ? entry.slice(0, cut) : entry;
            if (name && !seen[norm(name)]) {
              seen[norm(name)] = true;
              res.tail.push(entry);
            }
          });
        }
        res.hidden = rest.length + res.tail.length;
      } else {
        res.items = vis.slice().sort(byLabel);
      }
    } else if (m.p.indexOf('filter.p.m.bc_filter.') === 0) {
      res.items = vis.slice().sort(function (a, b) { return b.c - a.c; });
    }
    if (!brand) res.hidden = Math.max(0, res.items.length - res.limit);
    res.items.forEach(function (e, i) { if (i >= res.limit && e.a) res.open = true; });
    return res;
  }

  function makeItem(tpl, param, e, scope, extra) {
    var li = tpl.cloneNode(true);
    li.setAttribute('class', 'filter-item' + (extra ? ' bc-fv--extra' : ''));
    li.setAttribute('data-bc-key', textOf(e.l).toLowerCase().trim());
    var input = li.querySelector('input');
    var label = li.querySelector('label');
    var text = li.querySelector('.filter-item__label');
    var count = li.querySelector('.filter-item__count');
    var inner = li.querySelector('.filter-item__content-inner');
    var id = 'filter--' + param + '--' + liquidEncode(e.v) + '--' + scope + '--bc';
    input.setAttribute('name', param);
    input.setAttribute('value', e.v);
    input.setAttribute('id', id);
    input.setAttribute('data-filter', param + '=' + e.v);
    input.setAttribute('data-name-escaped', liquidEncode(param));
    input.setAttribute('data-value-escaped', liquidEncode(e.v));
    if (e.a) input.setAttribute('checked', '');
    else input.removeAttribute('checked');
    input.removeAttribute('disabled');
    if (label) {
      label.setAttribute('for', id);
      label.classList.remove('filter-item__content--disabled');
    }
    if (inner) {
      inner.setAttribute('data-background-matches-form-input-background', cfg.bgMatch);
      inner.setAttribute('data-form-input-background-is-transparent', cfg.bgTransparent);
    }
    if (text) text.innerHTML = e.l;
    if (count) {
      if (e.c > 0) count.textContent = '(' + e.c + ')';
      else count.remove();
    }
    return li;
  }

  function patchPrice(group, m) {
    var max = Math.ceil(m.rmax / 100);
    group.querySelectorAll('[data-range-input]').forEach(function (i) { i.setAttribute('max', max); });
    var hi = group.querySelector('[data-max-range-input]');
    if (hi) hi.setAttribute('placeholder', max);
    var title = group.querySelector('.filter-drawer__price-range-title');
    if (title && m.rmaxf0 && m.rmaxf) title.textContent = title.textContent.replace(m.rmaxf0, m.rmaxf);
  }

  function buildGroups(doc, tplDoc, scope, merged, otherActive) {
    var shells = tplDoc.querySelector('template[data-bc-shells="' + scope + '"]');
    var itemTpl = tplDoc.querySelector('template[data-bc-item="' + scope + '"]');
    var li0 = itemTpl ? itemTpl.content.querySelector('li') : null;
    var out = [];
    if (!shells) return out;
    merged.forEach(function (m) {
      var shell = shells.content.querySelector('[data-bc-group="' + cssEsc(m.p) + '"]');
      if (!shell) return;
      var g = doc.importNode(shell, true);
      if (m.t === 'price_range') {
        patchPrice(g, m);
        out.push(g);
        return;
      }
      var pres = present(m, otherActive);
      var ul = g.querySelector('ul[data-bc-values]');
      if (pres.hide || !ul || !li0) return;
      var tpl = doc.importNode(li0, true);
      ul.setAttribute('data-bc-limit', pres.limit);
      if (pres.open) ul.setAttribute('data-bc-more-open', '');
      pres.items.forEach(function (e, i) {
        ul.appendChild(makeItem(tpl, m.p, e, scope, i >= pres.limit));
      });
      var after = ul;
      if (pres.tail.length) {
        var script = doc.createElement('script');
        script.setAttribute('type', 'application/json');
        script.setAttribute('data-bc-longtail', '');
        script.textContent = JSON.stringify(pres.tail);
        after.parentNode.insertBefore(script, after.nextSibling);
        after = script;
      }
      if (pres.hidden > 0) {
        after.insertAdjacentHTML(
          'afterend',
          '<button type="button" class="bc-fmore fs-body-75" data-bc-more aria-expanded="' + pres.open + '">' +
            '<span class="bc-fmore__show">' + (cfg.el ? 'Περισσότερα' : 'Show more') + ' (+' + pres.hidden + ')</span>' +
            '<span class="bc-fmore__hide">' + (cfg.el ? 'Λιγότερα' : 'Show less') + '</span>' +
          '</button>'
        );
      }
      out.push(g);
    });
    return out;
  }

  function labelOf(merged, param, value) {
    for (var i = 0; i < merged.length; i++) {
      if (merged[i].p === param && merged[i].map[value]) return merged[i].map[value].l;
    }
    return escHtml(value);
  }

  function chipsHtml(doc, tplDoc, params, merged) {
    var t = tplDoc.querySelector('template[data-bc-active]');
    var src = t ? t.content.querySelector('[data-active-filters]') : null;
    if (!src) return '';
    var box = doc.importNode(src, true);
    var clear = box.querySelector('[data-clear-all-filters]');
    var have = {};
    var proto = null;
    box.querySelectorAll('[data-remove-filter]').forEach(function (a) {
      have[a.getAttribute('data-name') + '=' + a.getAttribute('data-value')] = true;
      proto = proto || a;
    });
    // chips for selected values partition 1 does not carry (e.g. a brand it has no products of)
    params.forEach(function (v, k) {
      if (!isFilter(k) || k.indexOf('filter.v.price') === 0 || have[k + '=' + v]) return;
      var rest = without(params, k, v).toString();
      var a;
      if (proto) {
        a = proto.cloneNode(true);
        Array.prototype.slice.call(a.childNodes).forEach(function (n) {
          if (n.nodeType === 3 || (n.nodeType === 1 && n.tagName !== 'svg' && !n.querySelector('svg'))) n.remove();
        });
        a.insertAdjacentHTML('afterbegin', labelOf(merged, k, v));
      } else {
        a = doc.createElement('a');
        a.className = 'active-filters__active-filter fs-body-75 no-transition';
        a.setAttribute('data-remove-filter', '');
        a.innerHTML = labelOf(merged, k, v);
      }
      a.setAttribute('href', path + (rest ? '?' + rest : ''));
      a.setAttribute('data-url-to-remove', rest);
      a.setAttribute('data-name', k);
      a.setAttribute('data-value', v);
      a.setAttribute('data-name-escaped', liquidEncode(k));
      a.setAttribute('data-value-escaped', liquidEncode(v));
      box.insertBefore(a, clear);
    });
    return box.outerHTML;
  }

  function pillsHtml(merged, total, params) {
    var count = 0;
    var anyActive = false;
    var out = '';
    total = Math.max(total, 1);
    var minCount = Math.max(3, Math.floor((total * 2) / 100));
    PILLS.forEach(function (param) {
      if (cfg.skipCategory && param === 'filter.p.m.bc_filter.category') return;
      var m = null;
      merged.forEach(function (x) { if (x.p === param && x.t === 'list') m = x; });
      if (!m) return;
      var vals = m.list.slice().sort(function (a, b) { return b.c - a.c; });
      var top = vals[0];
      if (!top) return;
      var selectable = vals.filter(function (e) { return e.c > 0 || e.a; }).length;
      var share = Math.floor((top.c * 100) / total);
      var take = 0;
      if (selectable >= 2 && share < 85 && share >= 10) {
        if (param === 'filter.p.m.bc_filter.category') take = 6;
        else if (param === 'filter.p.m.bc_filter.format') take = 2;
        else take = 3;
      }
      if (param === 'filter.p.m.bc_filter.fragrance_family' && count > 4) take = 0;
      var groupActive = vals.some(function (e) { return e.a; });
      if (!take && !groupActive) return;
      var taken = 0;
      vals.forEach(function (e) {
        if (!e.a && (taken >= take || count >= 10 || e.c < minCount)) return;
        if (e.a) anyActive = true;
        out += '<button type="button" class="bc-qf__pill" data-bc-pill="' + escHtml(param + '=' + e.v) + '" aria-pressed="' + e.a + '">' + e.l + '</button>';
        taken++;
        count++;
      });
    });
    if (count < 2 && !anyActive) return '';
    return '<div class="bc-qf" role="group" aria-label="' + (cfg.el ? 'Γρήγορα φίλτρα' : 'Quick filters') + '"><div class="bc-qf__track">' + out + '</div></div>';
  }

  // ---------------------------------------------------------------- products

  function cmpFor(sort) {
    switch (sort) {
      case 'price-ascending': return function (a, b) { return a.price - b.price; };
      case 'price-descending': return function (a, b) { return b.price - a.price; };
      case 'created-ascending': return function (a, b) { return a.created - b.created; };
      case 'created-descending': return function (a, b) { return b.created - a.created; };
      case 'title-ascending': return function (a, b) { return a.title.localeCompare(b.title); };
      case 'title-descending': return function (a, b) { return b.title.localeCompare(a.title); };
    }
    return null; // best selling / featured: partitions are random halves, so interleave them
  }

  function need(s) {
    return s.cmp ? PER : Math.ceil(PER / s.parts.length) + 1;
  }

  // every partition buffers enough products that the next page of the merge is exact
  function fill(s, n) {
    return Promise.all(s.parts.map(function (P) {
      if (P.buf.length >= n || P.page >= P.pages) return null;
      P.page++;
      return loadPage(P.handle, s.q, P.page).then(function (r) {
        P.pages = r.pages;
        r.items.forEach(function (it) {
          if (!P.seen[it.id]) {
            P.seen[it.id] = true;
            P.buf.push(it);
          }
        });
      });
    })).then(function () {
      var short = s.parts.some(function (P) { return P.buf.length < n && P.page < P.pages; });
      if (short) return fill(s, n);
    });
  }

  function take(s, n) {
    var out = [];
    var P = s.parts;
    while (out.length < n) {
      var pick = -1;
      var i;
      if (s.cmp) {
        for (i = 0; i < P.length; i++) {
          if (P[i].buf.length && (pick < 0 || s.cmp(P[i].buf[0], P[pick].buf[0]) < 0)) pick = i;
        }
      } else {
        for (i = 0; i < P.length; i++) {
          var c = (s.rr + i) % P.length;
          if (P[c].buf.length) {
            pick = c;
            break;
          }
        }
        if (pick >= 0) s.rr = (pick + 1) % P.length;
      }
      if (pick < 0) break;
      out.push(P[pick].buf.shift());
    }
    s.shown += out.length;
    return out;
  }

  function moreLink(s) {
    if (s.shown >= s.total) return '';
    s.seq++;
    return '<a href="' + path + '?bc_more=' + s.seq + '" class="btn btn--secondary no-transition" data-click-to-load>' + escHtml(cfg.t.loadMore) + '</a>';
  }

  function paginationText(shown, total) {
    var t = window.theme && window.theme.strings && window.theme.strings.pagination;
    if (!t || !t.viewing) return '';
    return t.viewing.replace('{{ of }}', '1-' + shown).replace('{{ total }}', total) + ' ' + (t.products || '');
  }

  // ---------------------------------------------------------------- the merged document

  function setBadge(doc, btn, cls, n, attr) {
    if (!btn) return;
    var b = btn.querySelector('.' + cls.split(' ')[0]);
    if (n > 0) {
      if (!b) {
        b = doc.createElement('span');
        b.className = cls;
        if (attr) b.setAttribute(attr, '');
        btn.appendChild(b);
      }
      b.textContent = n;
    } else if (b) {
      b.remove();
    }
  }

  function assemble(parts, params, filtered, nativeText, first) {
    var doc = document.implementation.createHTMLDocument('');
    ['[data-filter-bar]', '[data-mobile-filters]', '[data-filter-sidebar]', '[data-filter-drawer]', '[data-partial]'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) doc.body.appendChild(doc.importNode(el, true));
    });
    var tplDoc = parts[0].doc;
    var merged = mergeFilters(parts, params);
    var sort = params.get('sort_by') || '';
    var active = 0;
    var otherActive = false;
    params.forEach(function (v, k) {
      if (!isFilter(k)) return;
      active++;
      if (k !== 'filter.p.vendor') otherActive = true;
    });

    // sidebar + drawer groups
    var inner = doc.querySelector('[data-filter-sidebar] .filter-sidebar-inner');
    if (inner) {
      inner.querySelectorAll('.filter-drawer__group').forEach(function (g) { g.remove(); });
      var hidden = inner.querySelector('input[type="hidden"][name="sort_by"]');
      if (sort) {
        if (!hidden) {
          hidden = doc.createElement('input');
          hidden.setAttribute('type', 'hidden');
          hidden.setAttribute('name', 'sort_by');
          inner.insertBefore(hidden, inner.firstChild);
        }
        hidden.setAttribute('value', sort);
      } else if (hidden) {
        hidden.remove();
      }
      buildGroups(doc, tplDoc, 'sidebar', merged, otherActive).forEach(function (g) { inner.appendChild(g); });
    }
    var panel = doc.querySelector('[data-filter-drawer-panel]');
    if (panel) {
      var content = panel.querySelector('.filter-drawer__content');
      if (content) {
        content.querySelectorAll('.filter-drawer__group').forEach(function (g) { g.remove(); });
        buildGroups(doc, tplDoc, 'drawer', merged, otherActive).forEach(function (g) { content.appendChild(g); });
      }
      panel.classList.toggle('filters-active', active > 0);
      setBadge(doc, panel.querySelector('[data-filter-drawer-title]'), 'filter-drawer__title-count ff-body fs-body-100', active);
    }

    // chips, badges, sort state
    var chips = chipsHtml(doc, tplDoc, params, merged);
    doc.querySelectorAll('.filter-bar__active-filters, .filter-drawer__footer-active-filters').forEach(function (box) {
      box.innerHTML = chips;
    });
    var bar = doc.querySelector('[data-filter-bar]');
    if (bar) {
      // the theme submits only the form that changed; sorting from the bar must keep the filters
      bar.querySelectorAll('input[data-bc-carry]').forEach(function (i) { i.remove(); });
      params.forEach(function (v, k) {
        if (!isFilter(k)) return;
        var carry = doc.createElement('input');
        carry.setAttribute('type', 'hidden');
        carry.setAttribute('name', k);
        carry.setAttribute('value', v);
        carry.setAttribute('data-bc-carry', '');
        bar.appendChild(carry);
      });
      bar.classList.toggle('filters-active', active > 0);
      bar.querySelectorAll('.filter-bar__button--filters').forEach(function (btn) {
        setBadge(doc, btn, 'filter-bar__button-count', active, 'data-active-filter-count');
      });
    }
    setBadge(doc, doc.querySelector('[data-mobile-filters-toggle]'), 'mobile-filters__button-count', active);
    var current = sort || defaultSort;
    doc.querySelectorAll('input[name="sort_by"][type="radio"]').forEach(function (r) {
      if (r.getAttribute('value') === current) r.setAttribute('checked', '');
      else r.removeAttribute('checked');
    });
    var sortLabel = doc.querySelector('[data-sort-label]');
    var checked = doc.querySelector('[data-filter-bar] input[name="sort_by"][checked]');
    var checkedText = checked && checked.closest('label') && checked.closest('label').querySelector('.filter-item__label');
    if (sortLabel && checkedText) sortLabel.textContent = cfg.t.sortTitle + ': ' + checkedText.textContent.trim();

    // grid
    var partial = doc.querySelector('[data-partial]');
    var total;
    var ready = Promise.resolve();
    if (!filtered) {
      st = null;
      if (nativeText && !first) {
        var nd = new DOMParser().parseFromString(nativeText, 'text/html');
        var np = nd.querySelector('[data-partial]');
        if (np) {
          partial.innerHTML = np.innerHTML;
          partial.setAttribute('data-collection-products-count', np.getAttribute('data-collection-products-count'));
        }
      }
      total = +partial.getAttribute('data-collection-products-count') || 0;
    } else {
      total = parts.reduce(function (n, pt) { return n + (pt.data.count || 0); }, 0);
      var s = (st = {
        q: params.toString(),
        cmp: cmpFor(sort),
        total: total,
        shown: 0,
        rr: 0,
        seq: 0,
        parts: parts.map(function (pt) {
          var seen = {};
          pt.items.forEach(function (it) { seen[it.id] = true; });
          return { handle: pt.handle, buf: pt.items.slice(), page: 1, pages: pt.pages, seen: seen };
        })
      });
      ready = fill(s, need(s)).then(function () {
        var items = take(s, PER);
        var grid = partial.querySelector('.collection__products');
        if (grid) {
          grid.classList.toggle('collection__products--no-products', total === 0);
          grid.innerHTML = items.length
            ? items.map(function (it) { return it.html; }).join('')
            : '<div class="collection__empty"><div>' + escHtml(cfg.t.noProducts) + '</div><button type="button" class="btn btn--text-link" data-clear-all-filters>' + escHtml(cfg.t.clearFilters) + '</button></div>';
        }
        var trigger = partial.querySelector('.collection__infinite-trigger');
        if (trigger) trigger.innerHTML = moreLink(s);
        var pager = partial.querySelector('[data-pagination-item-count]');
        if (pager) pager.textContent = paginationText(s.shown, total);
        partial.setAttribute('data-collection-products-count', total);
      });
    }

    return ready.then(function () {
      doc.querySelectorAll('[data-results-count]').forEach(function (el) { el.innerHTML = resultsText(total); });
      partial.querySelectorAll('.bc-qf').forEach(function (el) { el.remove(); });
      var pills = pillsHtml(merged, total, params);
      var grid = partial.querySelector('.collection__products');
      if (pills && grid) grid.insertAdjacentHTML('beforebegin', pills);
      return '<!DOCTYPE html><html><body>' + doc.body.innerHTML + '</body></html>';
    });
  }

  function render(qs) {
    var params = cleanParams(qs);
    var filtered = hasFilter(params);
    var q = params.toString();
    var first = firstRender;
    firstRender = false;
    // without filters the grid is the collection's own; the facets then don't depend on the sort
    var nativeP = !filtered && !first
      ? realFetch(path + '?section_id=' + encodeURIComponent(cfg.sid) + (q ? '&' + q : ''), { credentials: 'same-origin' }).then(function (r) { return r.text(); })
      : Promise.resolve(null);
    return Promise.all([loadAll(filtered ? q : ''), nativeP]).then(function (r) {
      return assemble(r[0], params, filtered, r[1], first);
    });
  }

  function done() {
    htmlEl.classList.remove('bc-big-pending');
    setTimeout(function () { htmlEl.classList.remove('bc-big-init'); }, 400);
  }

  // ---------------------------------------------------------------- hooks into the theme

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : input && input.url;
    if (url && url.indexOf('section_id=') !== -1) {
      var u = new URL(url, location.href);
      if (u.pathname === path && u.searchParams.get('section_id') === cfg.sid) {
        return render(u.search.slice(1)).then(
          function (body) {
            done();
            return new Response(body, { status: 200, headers: { 'Content-Type': 'text/html; charset=utf-8' } });
          },
          function (err) {
            // a partition failed: show the collection unfiltered rather than nothing
            if (window.console) console.warn(err);
            done();
            return realFetch(input, init);
          }
        );
      }
    }
    return realFetch(input, init);
  };

  var xOpen = XMLHttpRequest.prototype.open;
  var xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    var u = String(url || '');
    this.__bcMore = u.indexOf('bc_more=') !== -1 && u.indexOf(path) !== -1;
    return xOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (!this.__bcMore) return xSend.apply(this, arguments);
    var xhr = this;
    var s = st;
    var reply = function (items, link) {
      var body = '<div class="collection__infinite-container">' + items + '</div><div class="collection__infinite-trigger">' + link + '</div>';
      Object.defineProperty(xhr, 'readyState', { value: 4, configurable: true });
      Object.defineProperty(xhr, 'status', { value: 200, configurable: true });
      Object.defineProperty(xhr, 'responseText', { value: body, configurable: true });
      Object.defineProperty(xhr, 'responseXML', { value: null, configurable: true });
      if (typeof xhr.onreadystatechange === 'function') xhr.onreadystatechange();
    };
    if (!s) {
      setTimeout(function () { reply('', ''); }, 0);
      return;
    }
    fill(s, need(s)).then(
      function () {
        if (s !== st) return reply('', '');
        var items = take(s, PER);
        reply(items.map(function (it) { return it.html; }).join(''), moreLink(s));
      },
      function () { reply('', ''); }
    );
  };

  // First render: the page arrives without filters; let the theme render them through its
  // own popstate path (same as back/forward), which ends in the fetch hook above.
  function start() {
    if (!htmlEl.classList.contains('bc-big-pending')) htmlEl.classList.add('bc-big-init');
    window.dispatchEvent(new PopStateEvent('popstate', { state: history.state }));
  }
  setTimeout(start, 0);
})();
